export default "__VITE_ASSET__CTc4SxZE__"